import React, { useEffect } from 'react';
import { CountdownProvider } from './contexts/CountdownContext';
import { initMetaPixel } from './utils/metaPixel';
import { StickyBar } from './components/StickyBar';
import { Hero } from './components/Hero';
import { BonusHighlight } from './components/BonusHighlight';
import { Vsl } from './components/Vsl';
import { Agitation } from './components/Agitation';
import { OfferStack } from './components/OfferStack';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <CountdownProvider data-id="element-0" data-mp="2wjqhr811w6n6">
      <div className="w-full bg-bone font-body" data-id="element-1" data-mp="2wj8evsjvuu6a">
        <StickyBar data-id="element-2" data-mp="28ufmg62gz4gf" />
        <main data-id="element-3" data-mp="28tmex2vosax8">
          <Hero data-id="element-4" data-mp="28te37ebavbnm" />
          <BonusHighlight data-id="element-5" data-mp="28suveqfd63nb" />
          <Vsl data-id="element-6" data-mp="28s2ztflro5x1" />
          <Agitation data-id="element-7" data-mp="23vkvggucm9l8" />
          <OfferStack data-id="element-8" data-mp="23w4ek0vqj40u" />
          <Testimonials data-id="element-9" data-mp="23utbk3a460as" />
          <Faq data-id="element-10" data-mp="23t8eo70bu59r" />
          <FinalCta data-id="element-11" data-mp="3ijxoypkvdyjd" />
        </main>
        <Footer data-id="element-12" data-mp="3iiwf2oflbi38" />
      </div>
    </CountdownProvider>;
}